export const environment = {
  production: true,
  supportEmail: 'support@festivalscope.com',
  ga: 'UA-18143336-1'
};
